import React, { FC } from "react";
import styled from "styled-components";

interface Props {
  marginTop?: number;
  marginBottom?: number;
}

const LineSeparatorThin: FC<Props> = ({
  marginTop = 24,
  marginBottom = 24,
}) => {
  return (
    <Separator dataMarginTop={marginTop} dataMarginBottom={marginBottom} />
  );
};

const Separator = styled.div<{
  dataMarginTop?: number;
  dataMarginBottom?: number;
}>`
  margin-top: ${(props) =>
    props.dataMarginTop ? `${props.dataMarginTop}px` : 0};
  margin-bottom: ${(props) =>
    props.dataMarginBottom ? `${props.dataMarginBottom}px` : 0};
  background: var(--sep-bdr-clr);
  height: 2px;
`;

export default LineSeparatorThin;
